import { Typography, SxProps, Theme } from "@mui/material";

interface SectionTitleProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const SectionTitle = ({ children, sx }: SectionTitleProps) => {
  return (
    <Typography
      variant="h2"
      sx={{
        textAlign: "center",
        fontSize: { md: "2.4rem", xs: "1.5rem" },
        marginBottom: "8px",
        color: "#1a1a2e",
        fontWeight: 600,
        wordBreak: { md: "keep-all", xs: "normal" },
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
